<SocialTags
	pageTitle="Nuestros Instructores"
	pageDesc="Nuestro equipo de instructores es especialista en cada una de sus disciplinas, te garantizamos la mejor experiencia de aprendizaje y sobre todo diversión en el camino."
	urlPath="/instructores/"
></SocialTags>

<style src="./style.scss">

</style>

<main id="dnsPage" class="mbsc-grid d-ns-page team-page">
	<nav>
		<MainMenu
			on:menuTapped={togglePages}
			selectedItem='team'
			path={router.path}
		></MainMenu>
	</nav>
	<Instructors></Instructors>
	<footer class="mbsc-row">
		<nav class="mbsc-col-12">
			<FooterMenu></FooterMenu>
		</nav>
		<CopyrightFooter></CopyrightFooter>
	</footer>
</main>

<script>
import { onMount, afterUpdate } from 'svelte';

import SocialTags from '@Components/SocialTags/index.svelte';
import MainMenu from '@Components/MainMenu/index.svelte';

import Instructors from '@Pages/Team/content.svelte';

import FooterMenu from '@Components/FooterMenu/index.svelte';
import CopyrightFooter from '@Components/CopyrightFooter/index.svelte';

import { Navigation, Utils } from '@Services';

const DEBUG = document.location.protocol === 'http:' ? true : false;

export let router = null;

let togglePages = (event) => {
  Navigation.goTo(event.detail.item);
};

afterUpdate(() => {});

onMount(async () =>{
	console.info('App ' + DEBUG + '::' + router.path);

	mobiscroll.settings = {
		theme: 'd-ns',
		themeVariant: 'light',
		lang: 'es'
	};

	mobiscroll.page('.team-page', {});

	Utils.scrollToTop();
});
</script>
